import React from 'react';
import ProgressCheckIcon from '../icons/ProgressCheck';
import * as S from './StepperProgress.styles';
const StepperProgress = ({
  steps,
  current,
  finished
}) => {
  const renderStep = (_, index) => {
    const isCurrent = index === current;
    const isCompleted = index < current || finished;
    const progress = current + 1 === index ? current / steps * 100 : current >= index ? 100 : 0;
    return /*#__PURE__*/React.createElement(S.StepperStep, {
      key: `stepper-progress-item-${index}`
    }, /*#__PURE__*/React.createElement(S.LabelContainer, null, /*#__PURE__*/React.createElement(S.StepperStepIndex, {
      filled: isCurrent || isCompleted
    }, isCompleted ? /*#__PURE__*/React.createElement(ProgressCheckIcon, null) : index + 1)), !!index && /*#__PURE__*/React.createElement(S.LinearProgress, {
      value: progress
    }));
  };
  return /*#__PURE__*/React.createElement(S.Root, null, Array.from({
    length: steps
  }).map(renderStep));
};
export default StepperProgress;